<template>
  <div class="h-dialogContainer h-track-tabPage">
    <div class="row"></div>
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div class="h-inputLit">{{$t('Observe.taskName')}}:</div>
          <ejs-textbox  v-model="taskName" :disabled="true"></ejs-textbox>
        </div>

        <div class="col-sm-6 h-col-inputBox" v-if="showSliceIdDetail" >
          <div class="h-inputLit">{{$t('Observe.sliceId')}}:</div>
          <ejs-textbox v-model="sliceId" :disabled="true" ></ejs-textbox>
        </div>
      </div>
            <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div class="h-inputLit">{{$t('Observe.startTime')}}:</div>
          <ejs-textbox  :disabled="true" v-model="startTime" ></ejs-textbox>
        </div>
        <div class="col-sm-6 h-col-inputBox">
          <div class="h-inputLit">{{$t('Observe.endTime')}}:</div>
          <ejs-textbox  :disabled="true" v-model="endTime"></ejs-textbox>
        </div>
      </div>
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div class="h-inputLit">{{$t('Observe.reportLevel')}}:</div>
          <ejs-textbox  v-model="reportLevel" :disabled="true"></ejs-textbox>
        </div>
      </div>

      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div class="h-inputLit">{{$t('Observe.allUserTag')}}:</div>
          <ejs-checkbox
            :label="$t('Observe.all')"
            ref="userTag"
            :checked="checkStatus"
            :disabled="true"
          ></ejs-checkbox>
        </div>
      </div>

      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div class="h-inputLit">{{$t('Observe.userIdList')}}:</div>
          <ejs-textbox
            multiline="true"
            class="e-input e-input-group"
            v-bind:disabled="true"
            v-model="userIdList"
          />
        </div>
      </div>
  </div>
</template>
<script>
import { EventBus } from "../../../plugins/eventBus";

export default {
  name: "ObserveDetail",
  components: {},
  data() {
    return {
      taskName: "",
      sliceId: "",
      showSliceIdDetail:false,
      reportLevel: "",
      userIdList: [],
      checkStatus: false,
      allUserTag: 0,
      startTime: '',
      endTime: '',
    };
  },
  methods: {
    setObserveId(data) {
      this.$nextTick(() => {
      if(data.typeCode==43||data.typeCode==44||data.typeCode==45||data.typeCode==46||data.typeCode==47||data.typeCode==48){
         this.showSliceIdDetail=false;
       }else{
         this.showSliceIdDetail=true;
       }
      this.taskName = data.taskName;
      this.sliceId = data.sliceId;
      this.userIdList = data.userIdList;
      this.startTime = new Date(data.startTime).Format("yyyy-MM-dd HH:mm:ss");
      this.endTime = new Date(data.endTime).Format("yyyy-MM-dd HH:mm:ss");
      if (1 === data.allUserTag) {
        this.checkStatus = true;
      } else {
        this.checkStatus = false;
      }
      if (1 === data.reportLevel) {
        this.reportLevel = this.$t('Observe.reportError');
      } else if (2 === data.reportLevel) {
        this.reportLevel = this.$t('Observe.reportWarning');
      } else {
        this.reportLevel = this.$t('Observe.reportInfo');
      }
     });
    },
    tabSelect(e) {
      if (e.isSwiped) {
        e.cancel = true;
      }
    }
  }
};
</script>
